/**
 * CasaMapa buyer quiz definition (Milestone 8).
 * Mapping logic lives in casaMapaQuizMapper.js — not in editable JSON.
 */

export const CASAMAPA_QUIZ_VERSION = "casamapa-quiz-v1";
export const CASAMAPA_QUIZ_SOURCE = "casamapa_buyer_quiz";
export const CASAMAPA_QUIZ_PROGRESS_TTL_MS = 7 * 24 * 60 * 60 * 1000;
export const CASAMAPA_QUIZ_MAX_MUNICIPALITIES = 3;

export const CASAMAPA_QUIZ_TIMELINES = Object.freeze([
  "immediately",
  "within_30_days",
  "within_3_months",
  "within_6_months",
  "more_than_6_months",
  "just_exploring",
]);

export const CASAMAPA_QUIZ_HOUSEHOLDS = Object.freeze([
  "just_me",
  "couple",
  "small_household",
  "larger_household",
]);

export const CASAMAPA_QUIZ_LIFESTYLES = Object.freeze([
  "parking",
  "more_space",
  "open_municipalities",
  "amenities",
  "outdoor",
  "walkable",
  "quiet",
  "lower_admin",
]);

/** Lifestyle keys that map into active search filters. */
export const CASAMAPA_QUIZ_LIFESTYLE_SEARCH_KEYS = Object.freeze(
  new Set(["parking", "more_space", "open_municipalities"])
);

export const CASAMAPA_QUIZ_MUNICIPALITIES = Object.freeze([
  { value: "Medellín", labelKey: "medellin" },
  { value: "Envigado", labelKey: "envigado" },
  { value: "Sabaneta", labelKey: "sabaneta" },
  { value: "Itagüí", labelKey: "itagui" },
  { value: "Bello", labelKey: "bello" },
  { value: "La Estrella", labelKey: "laEstrella" },
]);

export const CASAMAPA_QUIZ_PROPERTY_TYPES = Object.freeze([
  "apartment",
  "house",
  "studio",
  "penthouse",
  "duplex",
  "country_house",
  "lot",
]);

export const CASAMAPA_QUIZ_SALE_BUDGETS = Object.freeze([
  { value: 200000000, labelKey: "sale200" },
  { value: 400000000, labelKey: "sale400" },
  { value: 600000000, labelKey: "sale600" },
  { value: 800000000, labelKey: "sale800" },
  { value: 1200000000, labelKey: "sale1200" },
  { value: "unknown", labelKey: "unknown" },
]);

export const CASAMAPA_QUIZ_RENT_BUDGETS = Object.freeze([
  { value: 1500000, labelKey: "rent15" },
  { value: 2500000, labelKey: "rent25" },
  { value: 3500000, labelKey: "rent35" },
  { value: 5000000, labelKey: "rent50" },
  { value: 8000000, labelKey: "rent80" },
  { value: "unknown", labelKey: "unknown" },
]);

export const CASAMAPA_QUIZ_BEDROOM_OPTIONS = Object.freeze([
  { value: 0, labelKey: "studio" },
  { value: 1, labelKey: "beds1" },
  { value: 2, labelKey: "beds2" },
  { value: 3, labelKey: "beds3" },
  { value: 4, labelKey: "beds4" },
  { value: 5, labelKey: "beds5" },
  { value: null, labelKey: "noPreference" },
]);

export const CASAMAPA_QUIZ_BATHROOM_OPTIONS = Object.freeze([
  { value: 1, labelKey: "baths1" },
  { value: 2, labelKey: "baths2" },
  { value: 3, labelKey: "baths3" },
  { value: null, labelKey: "noPreference" },
]);

export const CASAMAPA_QUIZ_PARKING_OPTIONS = Object.freeze([
  { value: null, labelKey: "notRequired" },
  { value: 1, labelKey: "park1" },
  { value: 2, labelKey: "park2" },
  { value: 3, labelKey: "park3" },
]);

export const CASAMAPA_QUIZ_AREA_OPTIONS = Object.freeze([
  { value: null, labelKey: "noPreference" },
  { value: 60, labelKey: "area60" },
  { value: 80, labelKey: "area80" },
  { value: 100, labelKey: "area100" },
  { value: 150, labelKey: "area150" },
]);

/**
 * Ordered step ids. Visibility is resolved in getVisibleCasaMapaQuizSteps.
 */
export const CASAMAPA_QUIZ_STEP_IDS = Object.freeze([
  "listingType",
  "budget",
  "geography",
  "propertyType",
  "bedrooms",
  "bathsParking",
  "area",
  "lifestyle",
  "timeline",
  "review",
]);

export function createEmptyCasaMapaQuizAnswers(listingType = null) {
  return {
    listingType: listingType === "rent" || listingType === "sale" ? listingType : null,
    budgetMaxCop: null,
    budgetUnknown: false,
    municipalities: [],
    openToAreas: false,
    propertyTypes: [],
    propertyTypeAny: false,
    bedroomsMin: undefined,
    bathroomsMin: undefined,
    parkingMin: undefined,
    constructedAreaMinM2: undefined,
    household: null,
    lifestyles: [],
    timeline: null,
  };
}
